import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CSPModifySubscriptionResponse } from '../../models/csp.model';
import { ManageService } from '../../services/manage.service';

@Component({
  selector: 'app-finish-subscription',
  templateUrl: './finish-subscription.component.html',
  styleUrls: ['./finish-subscription.component.css']
})
export class FinishSubscriptionComponent implements OnInit {

  finishSubscriptions: CSPModifySubscriptionResponse[];

  constructor(
    private manageService: ManageService,
    public dialogRef: MatDialogRef<FinishSubscriptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.manageService.monitorPendingSubscriptions([]);
    if(this.data.finishSubscriptions){
      this.finishSubscriptions = this.data.finishSubscriptions;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
